var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "information-row mb-2 p-4"
  }, [_c('div', {
    staticClass: "row m-0 h-100 information-content",
    style: {
      backgroundColor: _vm.backgroundColor,
      color: _vm.textColor
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-7 col-xl-7 p-2 p-lg-3 p-xl-3 top-and-left-information-row"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-content-center justify-content-lg-start justify-content-xl-start"
  }, [_c('div', {
    staticClass: "text-center text-lg-left text-xl-left information-title d-flex align-items-center justify-content-start"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('div', {
    staticClass: "text-left pt-2 information-description",
    class: _vm.addEllipsis
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")])]), _c('div', {
    staticClass: "col-12 col-lg-5 col-xl-5 p-0 py-3 py-md-0 py-lg-0 py-xl-0 pr-md-3 d-flex justify-content-center align-items-center"
  }, [_vm.toLink && _vm.toLink.length > 0 ? _c('a', {
    attrs: {
      "href": _vm.toLink,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticClass: "button-class px-lg-5 px-xl-5",
    attrs: {
      "outlined": "",
      "rounded": "",
      "color": _vm.textColor,
      "width": _vm.buttonWidth,
      "height": _vm.buttonHeight
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonTitle) + " ")])], 1) : _c('router-link', {
    attrs: {
      "to": _vm.toRoute
    }
  }, [_c('v-btn', {
    staticClass: "button-class px-lg-5 px-xl-5",
    attrs: {
      "outlined": "",
      "rounded": "",
      "color": _vm.textColor,
      "width": _vm.buttonWidth,
      "height": _vm.buttonHeight
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonTitle) + " ")])], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }